import { z } from "zod";
import { VariableSchema } from "./Variable";

export const CreateVariableRequestSchema = VariableSchema.pick({
  name: true,
  unit: true,
  constraintText: true,
  isLookup: true,
  lookupTableId: true,
}).extend({
  categoryIds: z.array(z.number().positive().min(1)).optional(),
})

export type CreateVariableRequest = z.infer<typeof CreateVariableRequestSchema>;
